import React from 'react'
import { App } from 'antd'

/**
 * Bridges window-dispatched 'om_toast' events to antd's App-context message API.
 *
 * The HTTP interceptor lives outside the React tree, so it can't call
 * App.useApp() — and the static antd.message.* API does not reliably render
 * once <App> is wrapping the root in antd v5. This component is the conduit:
 * it subscribes to a custom event and forwards to the context-aware message
 * instance, which is the supported path in antd v5.
 *
 * Usage: render once inside <AntdApp>, e.g. <AntdApp><ToastBridge/><App/></AntdApp>.
 */
export default function ToastBridge() {
  const { message } = App.useApp()
  React.useEffect(() => {
    function onToast(e) {
      const detail = e?.detail || {}
      const type = detail.type === 'success' || detail.type === 'warning' || detail.type === 'info'
        ? detail.type
        : 'error'
      const text = typeof detail.text === 'string' && detail.text.length > 0
        ? detail.text
        : 'حدث خطأ'
      const duration = typeof detail.duration === 'number' ? detail.duration : undefined
      try {
        message[type](text, duration)
      } catch {
        // ignore — antd internals occasionally throw mid-unmount
      }
    }
    window.addEventListener('om_toast', onToast)
    return () => window.removeEventListener('om_toast', onToast)
  }, [message])
  return null
}
